import { Box, Card, CardContent } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { WsBreadCrumbs } from '../../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../../features/teams/helper/defaultValues';

import { AddAutomation } from './AddAutomation';

export const AddAutomationTemplate = () => (
  <>
    <WsBreadCrumbs
      breadCrumbsList={[
        ...getSettingBreadCrumbList(ISettingBreadCrumbTypes.AUTOMATION, Pages['AUTOMATION']),
        Pages['ADD_NEW_AUTOMATION'],
      ]}
    />
    <Card sx={{ width: '80%' }}>
      <CardContent sx={{ p: 3 }}>
        <AddAutomation
          header={
            <Box display="flex" flexDirection="column" rowGap={1}>
              <WsTypography variant={WsTypoVariants.TITLE} bold>{`Define Basic Info`}</WsTypography>
            </Box>
          }
        />
      </CardContent>
    </Card>
  </>
);
